import Eyebrow from "@/components/base/Eyebrow";
import PageHero from "@/components/feature/PageHero";
import CtaBand from "@/components/feature/CtaBand";
import ConfusedPairs from "@/pages/glossary/components/ConfusedPairs";
import GlossaryExplorer from "@/pages/glossary/components/GlossaryExplorer";

export default function Glossary() {
  return (
    <>
      <PageHero
        eyebrow="Reference"
        title="Forex glossary"
        description="The vocabulary that makes order types click — every term this site leans on, defined in one or two sentences. Search it, read the entry beside it, and come back whenever a word trips you up."
      />

      <section className="px-4 md:px-8 py-16 md:py-24 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <Eyebrow>The dictionary</Eyebrow>
            <span className="h-0.5 flex-1 bg-foreground-950"></span>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-end">
            <h2 className="lg:col-span-7 font-heading font-black uppercase leading-[0.92] tracking-tight text-foreground-950 text-3xl md:text-5xl">
              Every term this site leans on
            </h2>
            <p className="lg:col-span-5 text-sm md:text-base leading-relaxed text-foreground-600">
              Grouped the way you meet them in practice: the basics, the costs, the order types,
              execution, then risk. Type to narrow the list, then read the entry beside it — nothing
              navigates away, so you can look a word up without losing your place.
            </p>
          </div>
          <div className="mt-10">
            <GlossaryExplorer />
          </div>
        </div>
      </section>

      <ConfusedPairs />

      <CtaBand
        title="Now see those words doing something"
        description="Every term on this page shows up in a real fill — the spread you pay, the slippage you didn't plan for, the margin behind the position. Watch them happen in sequence."
        to="/order-execution"
        buttonLabel="See how execution works"
      />
    </>
  );
}